<template>
    <div class="mobile-menu-container">
        <router-link :to="{name: 'amenities-index'}" class="nav-item" @click.native="$store.commit('TOGGLE_MENU_EXPANDED', false)"
                     v-if="$store.getters.hasPermission('read amenities') && !$store.getters.hasRole('organisation')">
            <div class="icon-container">
                <font-awesome-icon :icon="['fal', 'icons-alt']"/>
            </div>
            <p>{{$t('nav.amenities')}}</p>
        </router-link>
        <router-link :to="{name: 'bookings-index'}" class="nav-item" @click.native="$store.commit('TOGGLE_MENU_EXPANDED', false)"
                     v-if="$store.getters.hasPermission('read bookings')">
            <div class="icon-container">
                <font-awesome-icon :icon="['fal', 'book-open']"/>
            </div>
            <p>{{$t('nav.bookings')}}</p>
        </router-link>
        <router-link :to="{name: 'calendar-index'}" class="nav-item" @click.native="$store.commit('TOGGLE_MENU_EXPANDED', false)"
                     v-if="!$store.getters.hasRole('organisation')">
            <div class="icon-container">
                <font-awesome-icon :icon="['fal', 'calendar']"/>
            </div>
            <p>{{$t('nav.calendar')}}</p>
        </router-link>
        <router-link :to="{name: 'rooms-index'}" class="nav-item" @click.native="$store.commit('TOGGLE_MENU_EXPANDED', false)"
                     v-if="$store.getters.hasPermission('read rooms')">
            <div class="icon-container">
                <font-awesome-icon :icon="['fal', 'house']"/>
            </div>
            <p>{{$t('nav.rooms')}}</p>
        </router-link>
        <router-link :to="{name: 'organisations-index'}" class="nav-item" @click.native="$store.commit('TOGGLE_MENU_EXPANDED', false)"
                     v-if="$store.getters.hasPermission('read organisations')">
            <div class="icon-container">
                <font-awesome-icon :icon="['far', 'building']"/>
            </div>
            <p>{{$t('nav.organisations')}}</p>
        </router-link>
        <router-link :to="{name: 'reports-index'}" class="nav-item" @click.native="$store.commit('TOGGLE_MENU_EXPANDED', false)"
                     v-if="$store.getters.hasPermission('read reports')">
            <div class="icon-container">
                <font-awesome-icon :icon="['fal', 'file-chart-pie']"/>
            </div>
            <p>{{$t('nav.reports')}}</p>
        </router-link>
        <router-link :to="{name: 'roles-index'}" class="nav-item" @click.native="$store.commit('TOGGLE_MENU_EXPANDED', false)"
                     v-if="$store.getters.hasPermission('read roles')">
            <div class="icon-container">
                <font-awesome-icon :icon="['fal', 'key']"/>
            </div>
            <p>{{$t('nav.roles_permissions')}}</p>
        </router-link>
        <router-link :to="{name: 'users-index'}" class="nav-item" @click.native="$store.commit('TOGGLE_MENU_EXPANDED', false)"
                     v-if="$store.getters.hasPermission('read users')">
            <div class="icon-container">
                <font-awesome-icon :icon="['fal', 'user-friends']"/>
            </div>
            <p>{{$t('nav.users')}}</p>
        </router-link>

    </div>
</template>

<script>
export default {
    name: "MobileMenu"
}
</script>

<style lang="scss" scoped>
.mobile-menu-container {
    @apply flex-1 grid grid-cols-2 content-start gap-y-12 gap-x-8 h-auto p-8 bg-white;

    @screen sm {
        @apply grid-cols-3;
    }

    @screen md {
        @apply hidden;
    }

    .nav-item {
        @apply flex flex-col items-center;

        .icon-container {
            @apply p-2 rounded-lg border-2 border-grey-light flex flex-col items-center justify-center;
            height: 40px;
            width: 40px;

            svg {
                @apply text-black w-auto;

                height: 18px;
            }
        }

        p {
            @apply text-black text-sm font-bold mt-4 text-center;
        }

        &:hover, &:focus {
            .icon-container {
                @apply border-primary;
            }
        }

        &.router-link-active {
            .icon-container {
                @apply bg-primary border-primary;

                svg {
                    @apply text-white;
                }
            }
        }
    }
}
</style>